__turbopack_context__.v({
  "inner": "AspectRatioContainer-module__P3KxwG__inner",
  "outer": "AspectRatioContainer-module__P3KxwG__outer",
  "withCssVariables": "AspectRatioContainer-module__P3KxwG__withCssVariables",
});
